import { buildDashGroup, DashboardGroup, DashboardItem } from './types'
import {
	CreditScoreDashItem,
	CrossSellItems,
	favoriteArticlesItem,
	StaticContent
} from 'experiences/dashboard/DashboardRoot/cards'
import { useSearchGroup } from 'experiences/dashboard/DashboardRoot/lib/useSearchGroup'
import { useWelcomeGroup } from 'experiences/dashboard/DashboardRoot/lib/useWelcomeGroup'

interface UseDashboardItemsReturn {
	dashboardGroups: Array<DashboardGroup>
	fallbackItems: Array<DashboardItem>
}

export const useDashboardItems = (): UseDashboardItemsReturn => {
	const fallbackItems = [CrossSellItems.loansItem, CrossSellItems.savingsItem, CrossSellItems.creditCardsItem]
	const searchGroup = useSearchGroup()
	const welcomeGroup = useWelcomeGroup()
	const dashboardGroups = [
		welcomeGroup,
		searchGroup,
		buildDashGroup(StaticContent.DebtConsolidationCalculator),
		buildDashGroup(CreditScoreDashItem),
		buildDashGroup(CrossSellItems.lifeInsuranceItem),
		buildDashGroup(favoriteArticlesItem)
	]
	return { dashboardGroups, fallbackItems }
}
